<div class="row mar">
  <div class="col-sm-2 ">
    <button class="btn btn-success addButton font-13 download-btn" (click)="getTableData()">Refresh Page</button>
  </div>
</div>
<app-base-template (modal)="openModal(content)" (searchmodal) = "searchModal()"(dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"[isExportDisable]="isExportDisable"[hideBtn]="hideBtn"[showExportBtn]="showExportBtn"[showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss"></ng-template>

<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter File Name"
                 [(ngModel)]="fileSelected"
                 matInput [formControl]="searchData"[matAutocomplete]="auto"
                >
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDetails()">
              <mat-option *ngIf="isLoading" class="is-loading">
                  <mat-spinner diameter="50"></mat-spinner>
              </mat-option>
              <ng-container *ngIf="!isLoading">
                  <mat-option *ngFor="let file of files" [value]="file.FileName">
                    {{ file.FileName }} 
                  </mat-option>
              </ng-container>
          </mat-autocomplete>
      </div>
    
      <div class="form-group">
          <input type="text" class="form-control radius-0 font-13" placeholder="Message" readonly
                 [(ngModel)]="message">
      </div>

    


  </div>
  <div class="modal-footer pad-8">

          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>

  </div>

  </ng-template>
  <notifier-container></notifier-container>